export default {
    'diagram3a3-3': {
        'diagram-task': 'Drag the points for each argument to the appropriate boxes.',
        'diagram-description': {
            '1': 'Information doesn’t wear out with use the way material goods do',
            '2': 'Data’s full worth is much greater than the income extracted from its first use',
            '3': 'Data’s true value needs to be considered in terms of all the possible ways it can be employed in the future.',
            '4': 'Innovative companies that learn to exploit their data effectively can reap potentially huge benefits.'
        },
        'elements': {
            'one': 'Companies need to value data in terms of all the possible ways it can be employed in the future',
            'two': 'Data is a “nonrivalrous” good – it can be processed over and over again, and harnessed for multiple purposes',
            'three': 'Data’s full worth is much greater than the income extracted from its first use',
            'four': 'Companies that learn to exploit their data effectively can reap potentially huge benefits.',
        }
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a3/diagram3/i18n/en.js